//#region src/helpers/constants.ts
const CONSTANTS = {
	tokenKey: "tokens",
	pkceCodeVerifierPrefix: "CodeVerifier",
	csrfProtectionState: "secureState"
};

//#endregion
export { CONSTANTS };